// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"409":"d781a71b","453":"3fe5bf88","720":"76ddca08"}[chunkId] + ".chunk.js";
};